export default __webpack_public_path__ + "static/media/warning--divided-highway--g8.c97f56db.png";